<template>
  <wrapper-edit
    :wrapper-width="wrapperWidth"
    @back="paasPageBack">
    <Form :label-width="120" :model="paasFormData" slot="form">
      <FormItem :label="item.name+`:`" v-for="(item,index) in fieldDatas" :key="`form-item-`+index">
        <Input v-model="paasFormData[item.title]" v-if="item.type === 'input'"></Input>
        <Input v-model="paasFormData[item.title]" type="textarea"
               :autosize="{minRows: 2,maxRows: 5}"
               v-if="item.type === 'textarea'"></Input>
        <Enum :enumJsonKey="item.param"  v-model="paasFormData[item.title]" type="radio" v-if="item.type === 'radio'">
        </Enum>
        <Enum :enumJsonKey="item.param"  v-model="paasFormData[item.title]" type="checkbox" v-if="item.type === 'checkbox'">
        </Enum>
        <Enum :enumJsonKey="item.param"  v-model="paasFormData[item.title]" v-if="item.type === 'select'">
        </Enum>
        <div v-if="item.type === 'entity'" >
          <div> {{  showEntityName[item.title]}}</div>
          <EntitySelect   v-model="paasFormData[item.title]"  :fieldConfig="entityConfig[index]" :key="item.title"   @click.native="setDataName(item.title)"
        :queryUrl="entityConfig[index].requestUrl" style="width: 30%;" @on-change="setEntitySelectData"   :multiply = "entityConfig[index].multiply">
         </EntitySelect>
        </div>
       
        <ColorPicker v-model="paasFormData[item.title]"  v-if="item.type === 'color'" recommend/>
        <div v-if="item.type === 'upload'">
          <div class="file-upload-list" v-if="paasFormData[item.title] && paasFormData[item.title] !== ''">
            <template>
              <img :src="paasFormData[item.title]">
              <div class="file-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(paasFormData[item.title])"></Icon>
                <Icon type="ios-trash-outline" @click.native="handleRemove(item.title)"></Icon>
              </div>
            </template>
          </div>
          <div class="fc-upload-btn" :ref="`uploadBtn`+index" @click="openUploadPanel(item.title,index)"
               v-if="!paasFormData[item.title] && paasFormData[item.title] === ''">
            <Icon type="md-camera" size="20"/>
          </div>
        </div>
        <div v-if="item.type === 'video'" >
          <multiUploader
            :fileList.sync="fileList"
            :businessId="paasFormData.id"
            :tempId="paasFormData.paasRepeatSubmitFlag"
            uploadTitle="上传视频"
            businessType="systemGroupData"
            :single="true"
            businessProperty="video"
            uploadType="video">
          </multiUploader>
        </div>
      </FormItem>
      <FormItem label="排序：" >
        <Input v-model="paasFormData.sort"
               clearable ></Input>
      </FormItem>
      <FormItem label="状态：" >
        <Enum :enumJsonKey="'crmdict-isDelete'"  v-model="paasFormData.isDelete" type="radio">
        </Enum>
      </FormItem>
      <div class="edit-oper-toolbar">
        <Button type="primary" @click="paasFormSubmit">保存</Button>
        <Button @click="paasPageBack" style="margin-left: 8px">返回</Button>
      </div>
      <FileModal id="fileModal"
                 @save-file="saveFileData"
                 :thumbnailWidth="thumWidth"
                 :thumbnailHeight="thumHeight"
                 :uploadParams="uploadParams"
                 :uploadAction="uploadAction"
                 @on-close="hiddenModal"
                 v-if="uploadModal"
                 class="paas-file-select" ></FileModal>
      <Modal title="图片预览" v-model="visible">
        <img :src="viewImg" v-if="visible" style="width: 100%">
      </Modal>
    </Form>
  </wrapper-edit>

</template>

<script>
  import wrapperEdit from "@components/paas/wrapper-edit";
  import Enum from '@components/paas/enum-form'; //枚举渲染
  import FileModal from '@views/sys/image/imageSelect';
  import EntitySelect from '../../../../../components/paas/refer/entitySelect.vue';
  import multiUploader from '@/components/paas/file/mult-uploader.vue';
  export default {
    name: "edit",
    components:{Enum,wrapperEdit,FileModal,EntitySelect,multiUploader},
    data(){
      return{
        serviceUrl:'/eb/system/group/data',
        currentIdFiledName: 'id',
        fieldDatas:[],
        fileList:[],
        systemGroupData:[],
        showEntityName:{},
        showEntityId:{},
        wrapperWidth:"80%",
        entityShowName:"",
        entityShowId:"",
        entityConfig:{
          "requestUrl":"",
          "idField":"id",
          "nameField":"name",
          "idFieldChild":"id",
          "nameFieldChild":"name"
        },
        paasFormData:{
          sort:'',
          isDelete:'',
          id:'',
          gid:'',
          paasRepeatSubmitFlag:"",
          value:"",
          name:"",
          createTime:"",
          updateTime:"",
          createUserId:"",
          createUserName:"",
          inputVal:""
        },
        uploadModal:false,
        uploadList:[],
        visible:false,
        uploadParams: {
          fileBusinessType: 'systemGroupData',
          fileBusinessProp: 'photo',
          fileBusinessId: '',
        },
        thumWidth:45,
        thumHeight:45,
        viewImg:'',
        currentUploadParam:'',  //当前点击的是哪个参数的上传数据
      }
    },
    computed:{
      uploadAction(){
        return this.$store.state.sysApi+'/sys/image/uploadAttacheSlice';
      },
    },
    created(){
      //通过路由获取的参数
      let queryParam = this.$route.query;
      let param = '';
      for(let key in queryParam) {
        if(key === "queryParam") {
          continue;
        }
        if(param) {
          param += "&";
        }
        param += key+"="+this.$route.query[key];
      }

      let path = "/getGroupDataById?"+param;
      this.axios.post(this.$store.state.sysApi+this.serviceUrl+path).then(res => {
      
        if (res.code === 200) {
          this.fieldDatas = res.data.fieldDatas;
          this.systemGroupData = res.data.systemGroupData;
          this.paasFormData.gid =  this.systemGroupData.gid;
          this.paasFormData.sort = this.systemGroupData.sort;
          this.paasFormData.isDelete = this.systemGroupData.isDelete;
          this.paasFormData.id = this.systemGroupData.id;
          this.paasFormData.value = this.systemGroupData.value;
          this.paasFormData.name = this.systemGroupData.name;
          this.paasFormData.createTime = this.systemGroupData.createTime;
          this.paasFormData.createUserId = this.systemGroupData.createUserId;
          this.paasFormData.createUserName = this.systemGroupData.createUserName;
          this.paasFormData.paasRepeatSubmitFlag = res.data.paasRepeatSubmitFlag;
          let fieldDataPropMap = res.data.systemGroupData.fieldDataPropMap;
          if(this.fieldDatas != null && this.fieldDatas.length > 0){
            for(let i = 0; i < this.fieldDatas.length; i++){
              if(this.fieldDatas[i].type === 'entity') {
                this.entityConfig[i] = JSON.parse(this.fieldDatas[i].param);
              } 
              for(let key in fieldDataPropMap){
                if(key === this.fieldDatas[i].title){
                  this.paasFormData[this.fieldDatas[i].title] = fieldDataPropMap[key].value;
                 if (this.fieldDatas[i].type === 'entity' && this.paasFormData[this.fieldDatas[i].title]){ 
                  this.showEntityName[key] = JSON.parse(this.paasFormData[this.fieldDatas[i].title]).name;
                 }
                 if(this.fieldDatas[i].type === 'video' && this.paasFormData[this.fieldDatas[i].title]) {
                    this.fileList.push(JSON.parse(fieldDataPropMap[key].value));
                  }
                  break;
                }
              }

            }
          }
        }
      }).catch(function(error){
        console.log(error)
        this.$Message.error('数据加载失败，请重试！');
      });
      
    },
    methods:{
      /**
       * 打开附件上传模态框
       */
      openUploadPanel(menuName,index,width,height){
        this.currentUploadParam = menuName;
        this.uploadModal = true;
        this.thumWidth = width;
        this.thumHeight = height;
        //计算当前位置的top以及left
        let scrollTop = document.documentElement.scrollTop;
        let top = this.$refs["uploadBtn"+index][0].getBoundingClientRect().top;
        this.$nextTick(()=>{
          document.getElementById("fileModal").style.top = (top+scrollTop-50)+"px";
          document.getElementById("fileModal").style.left = 0;
        });
      },
      /**
       * 隐藏附件弹出框
       */
      hiddenModal(){
        this.uploadModal = false;
      },
      handleRemove(menuName){
        this.paasFormData[menuName] = "";
        this.$forceUpdate();
      },
      handleView(showUrl){
        this.visible = true;
        this.viewImg = showUrl;
      },
      /**
       * 保存图片
       * @param files
       */
      saveFileData(files){
        if(this.currentUploadParam){
          this.paasFormData[this.currentUploadParam] = files[0].originalUrl;
          this.uploadModal = false;
        }
      },
      paasPageBack(){
         let url = "/eb/system/group/data/list?configName="+this.$route.query.key+"&paasCurrentFunctionId="+this.$route.query.paasCurrentFunctionId;
        this.$router.push({'path': url}); 
      },
      paasFormSubmit(){
        let that = this;
        //组装value{"wap_url":{"type":"input","value":""},"name":{"type":"input","value":"banner2"},"pic":{"type":"upload","value":""},"url":{"type":"input","value":""}}
        let valuejsonObject= JSON.parse(that.paasFormData.value);
        for(let k in valuejsonObject ){
          if(k ==='video_url') valuejsonObject[k].value =  this.fileList[0]
          else valuejsonObject[k].value = that.paasFormData[k];
        }
        if(that.paasFormData.sign_num != null) that.paasFormData.inputVal = that.paasFormData.sign_num ;
        let valueStr =JSON.stringify(valuejsonObject);
        that.paasFormData.value = valueStr;
        that.axios.post(this.$store.state.sysApi+this.serviceUrl+"/save", that.paasFormData).then(res => {
          if(res.code === 200) {
            that.$Message.info('数据保存成功！');
            that.paasPageBack();
          }
        }).catch(function (error) {
          that.$Message.error('数据保存失败，请重试！');
        });
      },
      setEntitySelectData(data){
        let newValue = {
          name:data.name,
          id:data.id
        }
        this.paasFormData = Object.assign({},{[this.entityShowName] : newValue, ...this.paasFormData});
        this.$set(this.showEntityName,this.entityShowName,data.name)
       },
        setDataName(item){
          this.entityShowName = item;
        }
    }
   
  }
</script>

<style scoped>
  @import "../../../../../assets/css/file/file-upload.css";
</style>
